// #region Dependencias
import styled from 'styled-components'
// #endregion

// #region Estilos
const StyledForm = styled.form`
  border-radius: inherit;
  display: flex;
  flex-direction: column;
`
// #endregion

/**
 * Componente para renderizar un formulario.
 *
 * @class
 * @example <Form onSubmit={handleSubmit}>...</Form>
 *
 * @param {Object} props - Propiedades del componente.
 * @param {Function} props.onSubmit - Callback que se ejecuta cuando se envía el formulario.
 * @param {React.ReactNode} props.children - Contenido que será renderizado dentro del componente.
 */
const Form = ({ children, ...props }) => {
  return <StyledForm {...props}>{children}</StyledForm>
}

export default Form
